import { useReactiveVar } from '@apollo/client';
import { leasingDetailModalVar } from '../../variables';
import { Dialog, DialogContent } from '@mui/material';
import React, { useCallback } from 'react';
import DetailComponent from './DetailComponent';

const DetailModalComponent = () => {
  const detailModal = useReactiveVar(leasingDetailModalVar);

  const close = useCallback((_, reason) => {
    if (reason === 'backdropClick') return true;
    leasingDetailModalVar({ open: false });
  }, []);

  return (
    <Dialog open={detailModal.open} maxWidth='sm' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>{detailModal.open && <DetailComponent detail={detailModal.detail} />}</DialogContent>
    </Dialog>
  );
};

export default DetailModalComponent;
